import {
  MMS_ADDON_SKU,
  MMS_CORNER_2_PACK_SKU,
  MMS_CORNER_3_PACK_SKU,
  MMS_CORNER_4_PACK_SKU,
} from './mms-constants'
import type { Product } from '@/js/services/RogueTypes'
import type { BuyRequest } from '@/js/services/types/order'
import type { ProductMeasurementConfig } from '../../RackTypes'

/**
 * Determines the camera zoom level for the MMS overview based on how many
 * addon units are configured and whether any corner pieces are included.
 * More addons = wider rack = further zoom needed to fit the whole thing.
 */
export function getMmsZoomLevel(buyRequest: BuyRequest, products: Record<string, Product>): number {
  const addons = buyRequest.children
    ?.filter(c => products[c.productId]?.sku === MMS_ADDON_SKU && c.qty > 0)
    
  const addonCount = addons?.length ?? 0
  const hasCorner  = addons?.some(br => br.children?.some(child =>
    [MMS_CORNER_2_PACK_SKU, MMS_CORNER_3_PACK_SKU, MMS_CORNER_4_PACK_SKU]
      .includes(products[child.productId]?.sku ?? '') && child.qty > 0
  )) ?? false

  // Large racks (7+ addons) or corner configurations need maximum zoom
  if (addonCount === 0) return 3
  if (addonCount > 6 || (addonCount > 1 && hasCorner)) return 3
  if (addonCount >= 1) return 2

  return 1.5
}

// meshValueMappings: each entry matches a Blender mesh name substring to its displayed inch value 
// (parallel = along the measurement axis, orthogonal = across it).
export const MMS_MEASUREMENT_CONFIG: ProductMeasurementConfig = {
  dynamic               : true,
  measurementDistance   : 0.4,
  maxMeasurementHeight  : 0.4,
  edgeDistanceThreshold : 0.25,
  defaultZoomLevel      : 1.5,
  getZoomLevel          : getMmsZoomLevel,
  meshValueMappings     : [
    { meshName: '_base', requires: 'mat', parallel: 36, orthogonal: 3 },
    { meshName: '_base', requires: 'main', parallel: 36, orthogonal: 3 },
    { meshName: '_shelf_43', parallel: 43, orthogonal: 0 },
    { meshName: '_shelf_70', parallel: 70, orthogonal: 0 },
    { meshName: '_corner', parallel: 45, orthogonal: 45 },
  ],
}
